import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput, LanguageSelection} from './LanguagePicker.style';
import {Language, languageResource} from './resources/LanguageResource';
import {isNullOrEmpty} from '../../utils';

export interface LanguagePickerProps {
    readonly dataSource: string[];
    readonly defaultValue: string;
    readonly resetState: boolean;
    readonly resetInput: boolean;
    readonly disabled: boolean;
    onChange: (languageSelection: string[]) => void;
}

export const LanguagePicker: React.VFC<LanguagePickerProps> = (props) => {
    const getOptions = (languageSelectionState: string[]) => {
        return languageResource.filter(language => ((isNullOrEmpty(language.value)) || (props.dataSource.includes(language.value))))
            .filter(language => ((isNullOrEmpty(language.value)) || (!languageSelectionState.includes(language.value))));
    };

    const [languageSelection, setLanguageSelection] = useState<string[]>([]);
    const [languageInput, setLanguageInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [languageOptions, setLanguageOptions] = useState<Language[]>(getOptions([]));

    const setState = (selectionState: string[], selectionOptions: Language[], resetInput: boolean) => {
        setLanguageSelection(selectionState);
        props.onChange(selectionState);
        setLanguageOptions(selectionOptions);
        if (resetInput) {
            setLanguageInput('');
        }
    };

    useEffect(() => {
        if (props.resetState) {
            setState([], getOptions([]), true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setLanguageInput(eventValue);
        let selectionOptions = languageOptions;
        let selectionState = [eventValue];
        if (props.resetInput) {
            selectionOptions = languageOptions.filter(language => (language.value !== eventValue));
            selectionState = [...languageSelection];
            if (!languageSelection.includes(eventValue)) {
                selectionState = selectionState.concat(eventValue);
            }
        }
        setState(selectionState, selectionOptions, props.resetInput);
    };

    const handleDelete = (languageKey: string) => {
        let selectionState = languageSelection.filter(language => (language !== languageKey));
        setState(selectionState, getOptions(selectionState), true);
    };

    const getLabel = (language: string) => {
        let label = '';
        if (language) {
            label = language;
        }

        return label;
    };

    return (
        <Accordion localizedHeadline={t('LANGUAGE_PICKER_CAPTION')}>
            <DropdownInput
                id={'languageId_'.concat(languageInput)}
                defaultValue={props.defaultValue ? props.defaultValue : ''}
                value={languageInput}
                options={languageOptions}
                disabled={props.disabled}
                onChange={handleInput}
            />
            {languageSelection?.map(language => {
                return props.resetInput &&
                    <LanguageSelection key={language} label={getLabel(language)} buttonClose
                                       onClose={() => handleDelete(language)}/>;
            })}
        </Accordion>
    );
};
